module.exports = __webpack_public_path__ + "img/3.36bcc713.png";